import React, { useEffect, useState } from 'react';
import { api } from '../apiService';
//import { version as frontendVersion } from '../../package.json';
import pkg from '../../package.json';

export const Version = () => {
  const [backendVersion, setBackendVersion] = useState('Loading...');
  const frontendVersion = pkg.version;//'1.0.5'; // From package.json //

  const getBackendVrsion = async () => {
    const [data, error] = await api.get(`version`);
    if (data) {
      setBackendVersion(data.version);
    }
  }

  useEffect( () => {
    getBackendVrsion();
  }, []);

return (
    <span>
      Version: {frontendVersion}
    </span>
  );
}